import parsePhoneNumber from "libphonenumber-js";
import { DateTime, Settings } from "luxon";
Settings.defaultLocale = "de-CH";

/**	JS Error-Logging direkt in Datenbank
 *
 */
const ERROR = "Error";
const INFO = "Information";
const SUCCESS = "Success";
const UNDEFINED = "Undefined";
const WARNING = "Warning";
window.ERROR = ERROR;
window.INFO = INFO;
window.SUCCESS = SUCCESS;
window.UNDEFINED = UNDEFINED;
window.WARNING = WARNING;

// Funktion die Fehler an Server übermittelt
app.saveToLog = async function (label, logData, level, noBrowser) {
  const browser = window.navigator.userAgent;
  let payload = logData;
  if (!noBrowser) {
    payload = { logData, browser };
  }
  let data = {
    action: label,
    entry: level || INFO,
    data: String(JSON.stringify(payload, undefined, 2))
  };

  const url = app.backend + "/log";
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(data)
  };

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    if (data.status != "success" || response.status >= 400) {
      throw new Error(
        "Log-Speicherung nicht möglich: " + response.status,
        data
      );
    }
  } catch (error) {
    console.error(error);
  }
};
// Ersetze window.onerror durch eigene Variante
window.addEventListener("error", function (event) {
  // Get the error properties from the error event object
  const { message, filename, lineno, colno, error } = event;
  let msg = "window.onerror";
  if (message.title) {
    msg += ` ${message.title}`;
  }
  if (message.detail) {
    msg += ` ${message.detail}`;
  }
  if (message.status) {
    msg += ` ${message.status}`;
  }

  app.saveToLog(msg, { message, filename, lineno, colno, error }, ERROR);
});
window.addEventListener("unhandledrejection", function (event) {
  // Get the error properties from the error event object
  let { message, fileName, lineNumber, columnNumber, stack } = event.reason;
  let msg = "window.onunhandledrejection";
  if (message.title) {
    msg += ` ${message.title}`;
  }
  if (message.detail) {
    msg += ` ${message.detail}`;
  }
  if (message.status) {
    msg += ` ${message.status}`;
  }

  if (!message && stack == Error) {
    // Mehr Details zu Fehler erhalten, der keine weiteren Angaben hat
    message = event;
  }

  app.saveToLog(
    msg,
    { message, fileName, lineNumber, columnNumber, stack },
    ERROR
  );
});

/**	Funktion um Dateiendung zu finden
 *
 */
app.getExtension = function (path) {
  // extract file name from full path ...
  // (supports `\\` and `/` separators)
  let basename = path.split(/[\\/]/).pop(),
    // get last position of `.`
    pos = basename.lastIndexOf(".");

  // if file name is empty or ...
  if (basename === "" || pos < 1) {
    //  `.` not found (-1) or comes first (0)
    return "";
  }
  // extract extension ignoring `.`
  return basename.slice(pos + 1);
};
// Ende Funktion um Dateiendung zu finden

/**	Wenn der Einsatz ab Sofort ist, werden einige Felder automatisch gesetzt
 *
 */
app.einsatzAbSofort = function () {
  let dateObjNow = DateTime.local();
  $("#i6-datum").val(dateObjNow.toISODate());
  $("#i6-zeit").val(dateObjNow.toLocaleString(DateTime.TIME_24_SIMPLE));
  setTimeout(function () {
    $("#i6-datum, #i6-zeit").trigger("change");
  }, 100);

  $("#i6-pickup[name='i6-fixpunkt']").prop("checked", true);
  $("#i6-sofort").prop("checked", true);
  $("#i6-flexibel").prop("checked", false);
};
// Ende Wenn der Einsatz ab Sofort ist, werden einige Felder automatisch gesetzt

/**	Telefonnummern
 *
 */
app.phoneFormat = function (number, link) {
  // Falls keine Nummer übermittelt wurde
  if (!number || String(number) === "") {
    return "";
  }

  const phoneNumber = parsePhoneNumber(number, "CH");
  if (!phoneNumber || phoneNumber.isValid() === false) {
    return number;
  }

  let formatted = "";
  if (phoneNumber.country == "CH") {
    formatted = phoneNumber.formatNational();
  } else {
    formatted = phoneNumber.formatInternational();
  }

  if (link) {
    return `<a href="${phoneNumber.getURI()}">${formatted}</a>`;
  } else {
    return formatted;
  }
};
// Ende Telefonnummern

/**		Transporttypen von Server als select-Optionen ausfüllen
 *
 */
app.ladeTransporttypen = async function app_ladeTransporttypen(count) {
  if (count > 5) {
    return;
  }

  const response = await fetch(`${app.backend}/transport_types`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    }
  });
  const data = await response.json();
  if (response.status >= 400) {
    setTimeout(() => {
      // retry
      app.ladeTransporttypen(count + 1 || 1);
    }, 500);
    throw new Error("Transporttypen nicht erhalten: " + response.status);
  }

  app.data.transportTypes = data;
  data.forEach((transport_type) => {
    let option = $("<option>", { value: transport_type.uuid })
      .data("priority", transport_type.priority)
      .data("id", transport_type.uuid)
      .text(transport_type.label);

    $("#i3-transportgrund").append(option);
  });
};
// Ende Transporttypen von Server als select-Optionen ausfüllen

/** 	Verarbeite Einstellungen
 *
 */
app.ladeEinstellungen = async function (callback, count) {
  if (count > 5) return;
// refactor with fetch
  const response = await fetch(`${app.backend}/settings/active`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    }
  });
  const data = await response.json();
  if (response.status >= 400) {
    // retry
    setTimeout(function () {
      app.ladeEinstellungen(callback, count + 1 || 1);
    }, 500);
    throw new Error("Error loading settings: " + response.status);
  }

  app.data.settings = app.data.settings || {};
  data.forEach((x) => {
    app.data.settings[x.key] = x;
  });

  if (callback) callback();
};
// Ende Verarbeite Einstellungen

/** 	Bearbeiten von Einstellungen
 *
 */
app.aktualisiereEinstellung = async function (uuid, data) {
  const response = await fetch(`${app.backend}/settings/${uuid}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/merge-patch+json",
      Accept: "application/json"
    },
    body: JSON.stringify(data)
  });
  const responseData = await response.json();
  if (responseData.status != "success" || response.status >= 400) {
    throw new Error(
      "app.aktualisiereEinstellung nicht möglich: " + response.status,
      responseData
    );
  }
  return responseData;
};
app.neueEinstellung = async function (data) {
  const response = await fetch(`${app.backend}/settings`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(data)
  });
  const responseData = await response.json();
  if (responseData.status != "success" || response.status >= 400) {
    throw new Error(
      "app.neueEinstellung nicht möglich: " + response.status,
      responseData
    );
  }
  return responseData;
};
// Ende Bearbeiten von Einstellungen

/** 	Verarbeite Einstellungen
 *
 */
app.verarbeiteEinstellungen = function (callback) {
  // Planungszeiten dynamisch anpassen
  $("caption .reload_time").text(app.data.settings?.reload_time?.value);
  $("caption .reload_time_dispo").text(
    app.data.settings?.reload_time_dispo?.value ??
      app.data.settings?.reload_time?.value
  );

  app.data.keys = Object.values(app.data.settings)
    .filter((x) => {
      // keys are named with date and random string, for example key_2024-07_ae5d6d
      return x.key.search(/key_\d{4}-\d{2}_.+/) !== -1;
    })
    .sort((a, b) => {
      let aActive = a.activeFrom && DateTime.fromISO(a.activeFrom);
      let bActive = b.activeFrom && DateTime.fromISO(b.activeFrom);
      if (aActive < bActive) {
        return 1;
      } else if (aActive > bActive) {
        return -1;
      } else {
        return 0;
      }
    });

  app.data.keys.forEach((publicKey) => {
    app.verarbeiteKeys(publicKey.value, publicKey.key);
  });

  if (callback) {
    callback();
  }
};
// Ende Verarbeite Einstellungen

/** 	Lade Glossar
 *
 */
app.ladeGlossar = async function (callback, count) {
  if (count > 5) return;

  let page = 1;
  let glossaries = [];
  await (async function loadData() {
    try {
      const resp = await fetch(`${app.backend}/glossaries?page=${page}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      });
      let data = await resp.json();
      glossaries = [...glossaries, ...data];
      if (data.length) {
        page++;
        await loadData();
      }
    } catch (e) {
      setTimeout(() => {
        // retry
        app.ladeGlossar(undefined, count + 1 || 1);
      }, 500);
      throw new Error("Glossaries nicht erhalten: ", e);
    }
  })();

  let glossaryEls = [];
  glossaries.forEach((item) => {
    glossaryEls.push($("<dt>").text(item.title));
    glossaryEls.push($("<dd>").text(item.value));
  });
  $("#glossarReveal dl").append(glossaryEls);

  if (callback) {
    callback();
  }
};
// Ende Lade Glossar

/* jQuery aktiv */
$(document).ready(function () {
  //	 Textlänge aktualisieren
  $("#anmeldeform #i7-bemerkungen").on("input", function () {
    let zeichen = $(this).val().length;
    if (zeichen > 249) {
      $("#i7-container .textlaenge").addClass("fehler-rot");
    } else {
      $("#i7-container .textlaenge").removeClass("fehler-rot");
    }
    $("#i7-container .textlaenge").text(String(zeichen) + "/250");
  });

  $("#missionDetail #i7-bemerkungen").on("input", function () {
    let zeichen = $(this).val().length;
    if (zeichen > 299) {
      $("#i7-container .textlaenge").addClass("fehler-rot");
    } else {
      $("#i7-container .textlaenge").removeClass("fehler-rot");
    }
    $("#i7-container .textlaenge").text(String(zeichen) + "/300");
  });

  /**	Zeigt/Versteckt die liegend/sitzend-Wahl */
  $("#anmeldeform, #missionDetail").on(
    "change appEvent.checked",
    "[name=i8-fahrzeug]",
    function () {
      let id = $(this).prop("id");

      // Ende	Zeigt/Versteckt die liegend/sitzend-Wahl
      if (id == "i8-taxi") {
        $("#anmeldeform, #missionDetail")
          .find("#i8-mobil")
          .prop("disabled", true)
          .velocity({ opacity: 0 }, { display: "none" })
          .find("input:radio")
          .prop("required", false)
          .prop("checked", false);
        $("#anmeldeform, #missionDetail")
          .find("#i8-rollstuhl")
          .prop("disabled", true)
          .velocity({ opacity: 0 }, { display: "none" })
          .find("input:radio")
          .prop("required", false)
          .prop("checked", false);
        $("#anmeldeform, #missionDetail")
          .find("#i8-helptext")
          .velocity("transition.flipBounceYIn", { duration: 400 });

        // Selbstzahler wieder einblenden
        $("#anmeldeform, #missionDetail")
          .find("#i8-selbstzahler-ja")
          .parent()
          .parent()
          .velocity("transition.flipBounceYIn", { duration: 400 });
      } else if (id == "i8-wheelchair_taxi") {
        $("#anmeldeform, #missionDetail")
          .find("#i8-mobil")
          .prop("disabled", true)
          .velocity({ opacity: 0 }, { display: "none", duration: 0 })
          .find("input:radio")
          .prop("required", false)
          .prop("checked", false);
        $("#anmeldeform, #missionDetail")
          .find("#i8-rollstuhl")
          .prop("disabled", false)
          .velocity("transition.flipBounceYIn", { duration: 400 })
          .find("input:radio")
          .prop("required", true);
        $("#anmeldeform, #missionDetail")
          .find("#i8-helptext")
          .velocity("transition.flipBounceYIn", { duration: 400 });

        // Selbstzahler wieder einblenden
        $("#anmeldeform, #missionDetail")
          .find("#i8-selbstzahler-ja")
          .parent()
          .parent()
          .velocity("transition.flipBounceYIn", { duration: 400 });
      } else if (id == "i8-lying_taxi") {
        $("#anmeldeform, #missionDetail")
          .find("#i8-mobil")
          .prop("disabled", true)
          .velocity({ opacity: 0 }, { display: "none", duration: 0 })
          .find("input:radio")
          .prop("required", false)
          .prop("checked", false);
        $("#anmeldeform, #missionDetail")
          .find("#i8-rollstuhl")
          .prop("disabled", true)
          .velocity({ opacity: 0 }, { display: "none" })
          .find("input:radio")
          .prop("required", false)
          .prop("checked", false);
        $("#anmeldeform, #missionDetail")
          .find("#i8-helptext")
          .velocity({ opacity: 0 }, { display: "none", duration: 0 });

        // Selbstzahler wieder einblenden
        $("#anmeldeform, #missionDetail")
          .find("#i8-selbstzahler-ja")
          .parent()
          .parent()
          .velocity("transition.flipBounceYIn", { duration: 400 });
      } else {
        // KTW
        $("#anmeldeform, #missionDetail")
          .find("#i8-rollstuhl")
          .prop("disabled", true)
          .velocity({ opacity: 0 }, { display: "none", duration: 0 })
          .find("input:radio")
          .prop("required", false)
          .prop("checked", false);
        if (id == "i8-rtw" || id == "i8-rth") {
          $("#anmeldeform, #missionDetail")
            .find("#i8-mobil")
            .prop("disabled", true)
            .velocity({ opacity: 0 }, { display: "none", duration: 0 })
            .find("input:radio")
            .prop("required", false)
            .prop("checked", false);
        } else {
          $("#anmeldeform, #missionDetail")
            .find("#i8-mobil")
            .prop("disabled", false)
            .velocity("transition.flipBounceYIn", { duration: 400 })
            .find("input:radio")
            .prop("required", true);
        }
        $("#anmeldeform, #missionDetail")
          .find("#i8-helptext")
          .velocity({ opacity: 0 }, { display: "none", duration: 0 });

        // Selbstzahler ausblenden
        $("#anmeldeform, #missionDetail")
          .find("#i8-selbstzahler-ja")
          .parent()
          .parent()
          .velocity({ opacity: 0 }, { display: "none", duration: 0 });
      }

      // Entferne alle Hintergrundfarben und setze bei nicht-KTW Fahrten eine Hintergrundfarbe
      $('#missionDetail input:radio[name="i8-fahrzeug"]')
        .parent()
        .removeClass("background-color-warning background-color-alert");
      if (id == "i8-rtw" || id == "i8-rth") {
        // Falls RTW oder RTH ausgwählt ist rot machen
        $("#missionDetail #" + id)
          .parent()
          .addClass("background-color-alert");
      } else if (id != "i8-ktw") {
        // alles andere ausser KTW gelb
        $("#missionDetail #" + id)
          .parent()
          .addClass("background-color-warning");
      }

      // Beim Disponenten die Fahrzeugauswahl dynamisch anpassen
      $("#missionDetail select#i0-fahrzeug option").each(function () {
        // value=0 ist Platzhalter zu Beginn, ignorieren
        if (Number($(this).val()) === 0) {
          return;
        }

        if (id == "i8-taxi" || id == "i8-wheelchair_taxi") {
          if (Number($(this).val()) < 1000) {
            $(this).prop("disabled", true);
          } else {
            $(this).prop("disabled", false);
          }
        } else if (id == "i8-ktw" || id == "i8-rtw" || id == "i8-rth") {
          if (Number($(this).val()) > 1000) {
            $(this).prop("disabled", true);
          } else {
            $(this).prop("disabled", false);
          }
        } else {
          // Falls nichts ausgwählt wurde
          $(this).prop("disabled", false);
        }
      });
    }
  );
});

/* Timeout um DOM-redraws abzuwarten */
app.wait = function (func, time) {
  if (!time) {
    time = 500;
  }
  setTimeout(function () {
    func();
  }, time);
};
/* Ende Timeout um DOM-redraws abzuwarten */

/* Caching von allen Ajax-Calls deaktivieren */
$(document).ready(function () {
  $.ajaxSetup({ cache: false });
});
/* Ende Caching von allen Ajax-Calls deaktivieren */

app.deepMerge = function (obj1, obj2) {
  const obj1Clone = structuredClone(obj1);
  const obj2Clone = structuredClone(obj2);
  const result = { ...obj1Clone };

  for (let key in obj2Clone) {
    if (obj2Clone.hasOwnProperty(key)) {
      if (
        obj2Clone[key] instanceof Object &&
        obj1Clone[key] instanceof Object
      ) {
        result[key] = app.deepMerge(obj1Clone[key], obj2Clone[key]);
      } else {
        result[key] = obj2Clone[key];
      }
    }
  }

  return result;
};
